import { render, staticRenderFns } from "./tester.vue?vue&type=template&id=257383ac"
import script from "./tester.vue?vue&type=script&lang=js"
export * from "./tester.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports